import React, { useState } from 'react';

export default function AltAnnouncementBar({ message, ctaLabel, ctaHref }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="alt-bar" role="complementary" aria-label="Announcement">
      <p className="alt-bar__text">
        {message}
        {ctaLabel && ctaHref && (
          <a className="alt-bar__cta" href={ctaHref}>
            {ctaLabel}&nbsp;&rarr;
          </a>
        )}
      </p>
      <button
        type="button"
        className="alt-bar__close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss announcement"
      >
        &times;
      </button>
    </div>
  );
}
